import { render, staticRenderFns } from "./TablaReserva.vue?vue&type=template&id=7f304a8f&scoped=true&"
import script from "./TablaReserva.vue?vue&type=script&lang=js&"
export * from "./TablaReserva.vue?vue&type=script&lang=js&"
import style0 from "./TablaReserva.vue?vue&type=style&index=0&id=7f304a8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f304a8f",
  null
  
)

export default component.exports